const accordion = {
    init() {
        var exemplesWrapper = document.querySelectorAll('.exemples-wrapper');

        if(exemplesWrapper) {
            exemplesWrapper.forEach(e => {

                let btnToggleAccordion = e.querySelector('.cta')
                let textWrapperAccordion = e.querySelector('.exemples-text')
                let blocWrapperAccordion = e.querySelector('.exemples-text .bloc')

                btnToggleAccordion.addEventListener('click', (e) => {
                    e.preventDefault()
                    console.log(btnToggleAccordion);

                    if(textWrapperAccordion.classList.contains('active')) {
                        textWrapperAccordion.classList.remove('active')
                        btnToggleAccordion.classList.remove('active')
                        textWrapperAccordion.style.height = 0
                    }
                    else {
                        textWrapperAccordion.classList.add('active')
                        btnToggleAccordion.classList.add('active')
                        textWrapperAccordion.style.height = blocWrapperAccordion.offsetHeight + "px"
                    }
                })
            })
        }

        var formationAccordions = document.querySelectorAll('.formation-wrapper');

        if(formationAccordions) {
            formationAccordions.forEach(e => {

                let btnToggleAccordion = e.querySelector('.formation-title')
                let textWrapperAccordion = e.querySelector('.formation-content')
                let blocWrapperAccordion = e.querySelector('.formation-content .text')

                btnToggleAccordion.addEventListener('click', (e) => {
                    e.preventDefault()

                    if(textWrapperAccordion.classList.contains('active')) {
                        textWrapperAccordion.classList.remove('active')
                        btnToggleAccordion.classList.remove('active')
                        textWrapperAccordion.style.height = 0
                    }
                    else {
                        textWrapperAccordion.classList.add('active')
                        btnToggleAccordion.classList.add('active')
                        textWrapperAccordion.style.height = blocWrapperAccordion.offsetHeight + "px"
                    }
                })
            })
        }

        var faqItemsWrapper = document.querySelectorAll('.faq-wrapper');

        if(faqItemsWrapper) {

            faqItemsWrapper.forEach(e => {

                let btnToggleAccordion = e.querySelector('.faq-title')
                let textWrapperAccordion = e.querySelector('.faq-content')
                let blocWrapperAccordion = e.querySelector('.faq-content .text')

                btnToggleAccordion.addEventListener('click', (e) => {
                    e.preventDefault()

                    if(textWrapperAccordion.classList.contains('active')) {
                        textWrapperAccordion.classList.remove('active')
                        btnToggleAccordion.classList.remove('active')
                        textWrapperAccordion.style.height = 0
                    }
                    else {
                        textWrapperAccordion.classList.add('active')
                        btnToggleAccordion.classList.add('active')
                        textWrapperAccordion.style.height = blocWrapperAccordion.offsetHeight + "px"
                    }
                })
            })
        }


        var caseClientWrapper = document.querySelectorAll('.customers-cases-wrapper .row');


        caseClientWrapper.forEach(row => {

            var caseList = row.querySelectorAll('.case');

            caseList.forEach(e => {
                console.log(e);

                let btnToggleAccordion = e.querySelector('.case-title')
                let textWrapperAccordion = e.querySelector('.case-content')
                let blocWrapperAccordion = e.querySelector('.case-content .text')

                btnToggleAccordion.addEventListener('click', (e) => {
                    e.preventDefault()

                    if(textWrapperAccordion.classList.contains('active')) {
                        textWrapperAccordion.classList.remove('active')
                        btnToggleAccordion.classList.remove('active')
                        textWrapperAccordion.style.height = 0
                    }
                    else {
                        textWrapperAccordion.classList.add('active')
                        btnToggleAccordion.classList.add('active')
                        textWrapperAccordion.style.height = blocWrapperAccordion.offsetHeight + "px"
                    }
                })
            });
        })


        var jobList = document.querySelector('.jobs-section .jobs-list');


        if(jobList) {
            var jobsList = jobList.querySelectorAll('.job');

            if(jobsList) {
                jobsList.forEach(job => {

                    console.log(job);
        
        
                    let btnToggleAccordion = job.querySelector('.job-title')
                    let textWrapperAccordion = job.querySelector('.job-content')
                    let blocWrapperAccordion = job.querySelector('.job-content .job-text')
        
                    btnToggleAccordion.addEventListener('click', (e) => {
                        e.preventDefault()
        
                        if(textWrapperAccordion.classList.contains('active')) {
                            textWrapperAccordion.classList.remove('active')
                            btnToggleAccordion.classList.remove('active')
                            textWrapperAccordion.style.height = 0
                        }
                        else {
                            textWrapperAccordion.classList.add('active')
                            btnToggleAccordion.classList.add('active')
                            textWrapperAccordion.style.height = blocWrapperAccordion.offsetHeight + "px"
                        }
                    })
                    
                })
            }
        }

    }
}

export default accordion;